import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator'
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { SelectItem } from '../../../../ui-components/select/Select';
import { reservationSlot, reservationRoom, reservation, reservationResponse } from '../../../../model/reservation';
import moment from 'moment';

export interface IActions {
    loadReservationRoom: (roomId: string, date: Date, type: "day" | "week") => void;
    loadRooms: () => void,
    loadReservationsSlot: (reservationSLot: reservationSlot, reservationRoom: reservationRoom) => void;
    addReservation: (reservation: reservation) => Promise<reservationResponse>;
    deleteReservation: (reservation: reservation) => Promise<reservationResponse>;
    setRoomSelected: (roomSelected: SelectItem) => void;
    setDaySelected: (daySelected: Date) => void;
    updateViewType: (viewType: "day" | "week") => void;
    resetResponse: () => void;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadReservationRoom: (roomId: string, date: Date, type: "day" | "week") => {
            let day = moment(date).format('YYYYMMDD');
            let weekNumber = moment(date).week();
            let year = moment(date).year();
            dispatch({
                type: Keys.LOADRESERVATIONROOM,
                payload: invokeApi({
                    path: type === "day" ? '/api/Rooms/' + roomId + "/day/" + day : '/api/Rooms/' + roomId + "/week/" + weekNumber + "/" + year,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        loadRooms: () => {
            dispatch({
                type: Keys.LOADROOMS,
                payload: invokeApi({
                    path: '/api/Rooms',
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        loadReservationsSlot: (reservationSlot: reservationSlot, reservationRoom: reservationRoom) => {
            dispatch({
                type: Keys.LOADRESEVATIONSSLOT,
                payload: invokeApi({
                    path: `/api/Reservations/list/${reservationRoom.roomId}/${reservationRoom.dayCode}/${reservationSlot.startingTime}`,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        addReservation: (reservation) => {
            return new Promise<reservationResponse>((res, rej) => dispatch({
                type: Keys.ADDRESERVATION,
                payload: invokeApi({
                    path: `/api/Reservations`,
                    method: 'POST',
                    body: reservation,
                    responseType: 'json'
                }).then(val => {
                    res(val);
                    return val;
                }).catch(err => {
                    rej(err);
                    throw err;
                })
            })
            )
        },
        deleteReservation: (reservation) => {
            return new Promise<reservationResponse>((res, rej) => dispatch({
                type: Keys.DELETERESERVATION,
                meta: reservation._id,
                payload: invokeApi({
                    path: `/api/Reservations/${reservation._id}`,
                    method: 'DELETE',
                    responseType: 'json'
                }).then(val => {
                    res(val);
                    return val;
                }).catch(err => {
                    rej(err);
                    throw err;
                })
            })
            )
        },
        setRoomSelected: (roomSelected) => {
            dispatch({
                type: Keys.SETROOMSELECTED,
                payload: roomSelected
            })
        },
        setDaySelected: (daySelected) => {
            dispatch({
                type: Keys.SETDAYSELECTED,
                payload: daySelected
            })
        },
        updateViewType: (viewType) => {
            dispatch({
                type: Keys.UPDATEVIEWTYPE,
                payload: viewType
            })
        },
        resetResponse: () => {
            dispatch({
                type: Keys.RESETRESPONSE
            })
        },
    }
}